module.exports = require("size-sensor");